export default __webpack_public_path__ + "static/media/treasurekitchen.24b7240a.png";